import { map, distinctUntilChanged } from 'rxjs/operators'

export default class SubjectRepository {
  constructor (baseSubject) {
    this._baseSubject = baseSubject
    this.subjects = {}
  }

  getOrRegisterSubject (criteria, predicate) {
    console.log('register', criteria)
    const subjectIdentifier = JSON.stringify(criteria)
    const existingSubject = this.subjects[subjectIdentifier]

    if (existingSubject) {
      return existingSubject
    } else {
      const subject = this._baseSubject.pipe(
        map(predicate),
        distinctUntilChanged()
      )
      this.subjects[subjectIdentifier] = subject
      return subject
    }
  }
}
